import { useState, useEffect, useCallback } from 'react';

const USE_MOCK = process.env.REACT_APP_USE_MOCK === 'true';

const MOCK_PETTY_CASH = {
  initialFloat: 11500,
  currency: 'SGD',
  topUps: [
    { id: 'topup-1', amount: 11500, date: '2026-01-01', note: 'Initial petty cash float' },
  ],
  expenses: [
    // ── Jan 2026 ──
    { id: 'exp-1', description: 'Muay Thai', amount: 1500.00, currency: 'SGD', category: 'Other', businessId: 'gym-1', date: '2026-01-30', receiptUrl: null },
    { id: 'exp-2', description: 'Phone Bill', amount: 86.06, currency: 'SGD', category: 'Utilities', businessId: null, date: '2026-01-31', receiptUrl: null },
    // ── Feb 2026 ──
    { id: 'exp-3', description: 'Lure Haven - 17x line cleaning with spool + 12x without spool', amount: 460.00, currency: 'SGD', category: 'Equipment', businessId: 'project-1', date: '2026-02-02', receiptUrl: null },
    { id: 'exp-4', description: 'Laptop Lenovo X1 Carbon', amount: 2899.40, currency: 'SGD', category: 'Equipment', businessId: null, date: '2026-02-11', receiptUrl: null },
    { id: 'exp-5', description: 'Lure Haven - 2x Varivas P.E Line Avani Jigging Max Power 10x10 X9 300m', amount: 128.25, currency: 'SGD', category: 'Equipment', businessId: 'project-1', date: '2026-02-12', receiptUrl: null },
    { id: 'exp-6', description: 'Snow Monsters - Snowboarding Lesson (Nigel)', amount: 88.00, currency: 'SGD', category: 'Other', businessId: null, date: '2026-02-24', receiptUrl: null },
    { id: 'exp-7', description: 'Snow Monsters - Snowboarding Lesson (Jolene)', amount: 88.00, currency: 'SGD', category: 'Other', businessId: null, date: '2026-02-24', receiptUrl: null },
    { id: 'exp-8', description: 'Decathlon - 4x Snowboarding Pads + Butt Pad', amount: 146.40, currency: 'SGD', category: 'Equipment', businessId: null, date: '2026-02-25', receiptUrl: null },
    { id: 'exp-9', description: 'Snow Monsters - 30 sessions', amount: 1800.00, currency: 'SGD', category: 'Other', businessId: null, date: '2026-02-26', receiptUrl: null },
    { id: 'exp-10', description: 'Snow Monsters - Snowboarding Lesson (Nigel)', amount: 88.00, currency: 'SGD', category: 'Other', businessId: null, date: '2026-02-26', receiptUrl: null },
    { id: 'exp-11', description: 'Snow Monsters - Snowboarding Lesson (Jolene)', amount: 88.00, currency: 'SGD', category: 'Other', businessId: null, date: '2026-02-26', receiptUrl: null },
    { id: 'exp-12', description: 'Phone Bill', amount: 36.75, currency: 'SGD', category: 'Utilities', businessId: null, date: '2026-02-27', receiptUrl: null },
    // ── Mar 2026 ──
    { id: 'exp-13', description: 'Anthropic AI - Subscription', amount: 7.13, currency: 'SGD', category: 'Professional Services', businessId: null, date: '2026-03-01', receiptUrl: null },
    { id: 'exp-14', description: 'DigitalOcean - VPS Subscription', amount: 5.76, currency: 'SGD', category: 'Professional Services', businessId: null, date: '2026-03-01', receiptUrl: null },
    { id: 'exp-15', description: 'OpenAI - Subscription', amount: 143.67, currency: 'SGD', category: 'Professional Services', businessId: null, date: '2026-03-02', receiptUrl: null },
    { id: 'exp-16', description: 'OpenAI - Subscription', amount: 14.36, currency: 'SGD', category: 'Professional Services', businessId: null, date: '2026-03-02', receiptUrl: null },
    { id: 'exp-17', description: 'Hostinger - VPS Subscription (2 years)', amount: 314.23, currency: 'SGD', category: 'Professional Services', businessId: null, date: '2026-03-05', receiptUrl: null },
    { id: 'exp-18', description: 'Claude.AI - Subscription (1 year)', amount: 300.00, currency: 'SGD', category: 'Professional Services', businessId: null, date: '2026-03-10', receiptUrl: null },
    { id: 'exp-19', description: 'Perplexity.AI - Credit Top Up for API Key for Research', amount: 13.27, currency: 'SGD', category: 'Professional Services', businessId: null, date: '2026-03-10', receiptUrl: null },
    { id: 'exp-20', description: 'Claude.AI - CCY Conversion Fee', amount: 3.00, currency: 'SGD', category: 'Professional Services', businessId: null, date: '2026-03-11', receiptUrl: null },
    { id: 'exp-21', description: 'Anthropic AI - Subscription', amount: 36.10, currency: 'SGD', category: 'Professional Services', businessId: null, date: '2026-03-14', receiptUrl: null },
    { id: 'exp-22', description: 'Anthropic AI - Subscription', amount: 36.10, currency: 'SGD', category: 'Professional Services', businessId: null, date: '2026-03-14', receiptUrl: null },
    { id: 'exp-23', description: 'Anthropic AI - Subscription', amount: 144.31, currency: 'SGD', category: 'Professional Services', businessId: null, date: '2026-03-18', receiptUrl: null },
    { id: 'exp-24', description: 'Anthropic AI - Subscription', amount: 144.43, currency: 'SGD', category: 'Professional Services', businessId: null, date: '2026-03-21', receiptUrl: null },
    { id: 'exp-25', description: 'Anthropic AI - Subscription', amount: 144.43, currency: 'SGD', category: 'Professional Services', businessId: null, date: '2026-03-22', receiptUrl: null },
    { id: 'exp-26', description: 'Muay Thai', amount: 1500.00, currency: 'SGD', category: 'Other', businessId: 'gym-1', date: '2026-03-23', receiptUrl: null },
    { id: 'exp-27', description: 'Anthropic AI - Subscription', amount: 144.82, currency: 'SGD', category: 'Professional Services', businessId: null, date: '2026-03-23', receiptUrl: null },
    { id: 'exp-28', description: 'Anthropic AI - Subscription', amount: 5.45, currency: 'SGD', category: 'Professional Services', businessId: null, date: '2026-03-24', receiptUrl: null },
    { id: 'exp-29', description: 'Anthropic AI - Subscription', amount: 144.25, currency: 'SGD', category: 'Professional Services', businessId: null, date: '2026-03-25', receiptUrl: null },
    { id: 'exp-30', description: 'Anthropic AI - Subscription', amount: 55.04, currency: 'SGD', category: 'Professional Services', businessId: null, date: '2026-03-28', receiptUrl: null },
    { id: 'exp-31', description: 'Netlify - ReefsRivers website testing', amount: 11.97, currency: 'SGD', category: 'Professional Services', businessId: 'project-1', date: '2026-03-28', receiptUrl: null },
    { id: 'exp-32', description: 'Anthropic AI - Subscription', amount: 11.00, currency: 'SGD', category: 'Professional Services', businessId: null, date: '2026-03-29', receiptUrl: null },
    { id: 'exp-33', description: 'Netlify - Domain Hosting', amount: 11.60, currency: 'SGD', category: 'Professional Services', businessId: null, date: '2026-03-29', receiptUrl: null },
    { id: 'exp-34', description: 'Phone Bill', amount: 84.58, currency: 'SGD', category: 'Utilities', businessId: null, date: '2026-03-29', receiptUrl: null },
  ],
};

export default function usePettyCash(userId) {
  const [pettyCash, setPettyCash] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!userId) { setLoading(false); return; }

    if (USE_MOCK) {
      setPettyCash(JSON.parse(JSON.stringify(MOCK_PETTY_CASH)));
      setLoading(false);
      return;
    }

    // Firebase: load from users/{userId}/pettyCash doc
    let unsubscribe;
    async function init() {
      try {
        const { db } = await import('../firebase/config');
        const { doc, onSnapshot, setDoc } = await import('firebase/firestore');

        const docRef = doc(db, 'users', userId, 'settings', 'pettyCash');
        unsubscribe = onSnapshot(docRef, (snap) => {
          if (snap.exists()) {
            setPettyCash(snap.data());
          } else {
            const initial = { initialFloat: 0, currency: 'SGD', topUps: [], expenses: [] };
            setDoc(docRef, initial);
            setPettyCash(initial);
          }
          setLoading(false);
        });
      } catch (err) {
        console.error('PettyCash init failed:', err);
        setLoading(false);
      }
    }
    init();
    return () => unsubscribe && unsubscribe();
  }, [userId]);

  const savePettyCash = useCallback(async (data) => {
    setPettyCash(data);
    if (USE_MOCK) return;

    const { db } = await import('../firebase/config');
    const { doc, setDoc } = await import('firebase/firestore');
    await setDoc(doc(db, 'users', userId, 'settings', 'pettyCash'), data);
  }, [userId]);

  const addExpense = useCallback((expense) => {
    setPettyCash((prev) => {
      const updated = {
        ...prev,
        expenses: [...prev.expenses, { id: `exp-${Date.now()}`, ...expense }],
      };
      if (!USE_MOCK) savePettyCash(updated);
      return updated;
    });
  }, [savePettyCash]);

  const updateExpense = useCallback((expenseId, updates) => {
    setPettyCash((prev) => {
      const updated = {
        ...prev,
        expenses: prev.expenses.map((e) => (e.id === expenseId ? { ...e, ...updates } : e)),
      };
      if (!USE_MOCK) savePettyCash(updated);
      return updated;
    });
  }, [savePettyCash]);

  const deleteExpense = useCallback((expenseId) => {
    setPettyCash((prev) => {
      const updated = {
        ...prev,
        expenses: prev.expenses.filter((e) => e.id !== expenseId),
      };
      if (!USE_MOCK) savePettyCash(updated);
      return updated;
    });
  }, [savePettyCash]);

  const addTopUp = useCallback((topUp) => {
    setPettyCash((prev) => {
      const updated = {
        ...prev,
        topUps: [...prev.topUps, { id: `topup-${Date.now()}`, ...topUp }],
      };
      if (!USE_MOCK) savePettyCash(updated);
      return updated;
    });
  }, [savePettyCash]);

  const updateSettings = useCallback((settings) => {
    setPettyCash((prev) => {
      const updated = { ...prev, ...settings };
      if (!USE_MOCK) savePettyCash(updated);
      return updated;
    });
  }, [savePettyCash]);

  // Computed values
  const totalTopUps = pettyCash ? pettyCash.topUps.reduce((s, t) => s + t.amount, 0) : 0;
  const totalExpenses = pettyCash ? pettyCash.expenses.reduce((s, e) => s + e.amount, 0) : 0;
  const balance = totalTopUps - totalExpenses;

  return {
    pettyCash,
    loading,
    balance,
    totalTopUps,
    totalExpenses,
    addExpense,
    updateExpense,
    deleteExpense,
    addTopUp,
    updateSettings,
    savePettyCash,
  };
}
